import fetch from 'lib/fetch'
import { CHECKOUT_ENDPOINT } from './constants'
import { RequestMethod } from './RequestMethod'

interface CheckoutPayload {
  cartItemIds?: string[]
  subscriptionId?: string
  aobAcknowledged?: boolean
  includeFreeGift?: boolean
  phiCustomerInsuranceId?: string
}

export default function checkout(
  payload: CheckoutPayload
): Promise<APIResponse.Checkout> {
  return fetch(CHECKOUT_ENDPOINT, {
    method: RequestMethod.POST,
    body: JSON.stringify(payload),
  })
}
